import {API_SERVERLESS, getFetch, postFetch} from '~commonApi';
import {ISearchItem} from '../../types';

export function apiCommunicationCentreInternalSearchInbox(
    criteria: any,
    DEFAULT_CRITERIA: any = {},
    excelTranslations?: boolean
) {
    const params = {...criteria};
    const requestParams = Object.keys(params)
        .filter(i => params[i] !== DEFAULT_CRITERIA[i])
        .map(k => `${k}=${params[k]}`);
    return (criteria.excel ? postFetch : getFetch)(
        `${API_SERVERLESS}/communicationCentreInternal/v4/CCIIS/inbox/search?${requestParams.join('&')}`,
        true,
        excelTranslations
    );
}

export function apiCommunicationCentreInternalInboxClientsList() {
    return getFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCIICL/inbox/clientsList`, true);
}

export function apiCommunicationCentreSearchList(): Promise<{
    data: {
        searches: ISearchItem[];
    };
}> {
    return getFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCHSS/header/savedSearches`, true);
}

export function apiCommunicationCentreInternalFlagMessage(communicationId: number): Promise<{
    data: string;
}> {
    return postFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCIIMMF/inbox/markMessagesFlagged`, true, {
        communicationIds: [communicationId],
    });
}

export function apiCommunicationCentreInternalUnFlagMessage(communicationId: number): Promise<{
    data: string;
}> {
    return postFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCIIMMNF/inbox/markMessagesNotFlagged`, true, {
        communicationIds: [communicationId],
    });
}

export function apiCommunicationCentreInternalInboxMessageArchive(communicationIds: number[]) {
    return postFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCIIMA/inbox/messageArchive`, true, {
        communicationIds,
    });
}

export function apiCommunicationCentreInternalInboxMarkMessagesRead({
    communicationIds,
    all,
}: {
    communicationIds?: number[];
    all?: 'inbox' | 'archive';
}): Promise<{
    data: string;
}> {
    const JSONRequest: any = {};
    communicationIds && (JSONRequest.communicationIds = communicationIds);
    all && (JSONRequest.all = all);
    return postFetch(
        `${API_SERVERLESS}/communicationCentreInternal/v4/CCIIMMR/inbox/markMessagesRead`,
        true,
        JSONRequest
    );
}

export function apiCommunicationCentreInternalInboxMarkMessagesNotRead({
    communicationIds,
}: {
    communicationIds: number[];
}): Promise<{
    data: string;
}> {
    return postFetch(`${API_SERVERLESS}/communicationCentreInternal/v4/CCIIMMNR/inbox/markMessagesNotRead`, true, {
        communicationIds,
    });
}
